<script lang="ts" setup>
import DuplicateItem from './DuplicateItem.vue';
import { UserToCreate } from '../NewUser/useCreateMultipleUsers';
import { useLocale } from '../../composables/useLocale';

type Props = {
  duplicateUsers: UserToCreate[];
  disabled: boolean;
  hideTitle?: boolean;
};
withDefaults(defineProps<Props>(), {
  hideTitle: false,
});

type Emits = {
  (e: 'update', user: UserToCreate, state: 'add' | 'remove'): void;
};

const emit = defineEmits<Emits>();

const { t } = useLocale();

const onUndoClicked = (user: UserToCreate) => {
  emit('update', user, 'remove');
};

const onDeleteClicked = (user: UserToCreate) => {
  emit('update', user, 'add');
};

defineExpose({
  isValid: () => {
    return true;
  },
});
</script>

<template>
  <v-row>
    <v-col>
      <h4 v-if="!hideTitle">{{ t(`lcp.duplicate_title`) }}</h4>
      <p>
        {{ t('lcp.duplicate_users_warning') }}
      </p>
    </v-col>
  </v-row>
  <v-row class="mt-6">
    <v-col>
      <DuplicateItem
        v-for="(user, index) in duplicateUsers"
        :key="index"
        :name="user.name"
        :email="user.email"
        :userRole="user.role"
        :disabled="disabled"
        @undo="() => onUndoClicked(user)"
        @delete="() => onDeleteClicked(user)"
      />
    </v-col>
  </v-row>
</template>
